import { DEFAULT_COVER_IMG } from '@/common/components/HeadMetaTags/HeadMetaTags';
import { PageConfig } from '@/common/routes/RouteBuilder';

export const Page404Config: PageConfig = {
  readableName: '404',
  analyticsGaName: '404',
  analyticsAthenaName: '404',
  pagePathnames: ['/404'],
  displayPromoBar: false,
  defaultMeta: {
    title: '404 Not Found - Displate | Make Your Home Awesome',
    description: '404 Not Found - Displate | Make Your Home Awesome',
    coverImage: DEFAULT_COVER_IMG,
  },
};
